// react components
import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import axios from 'axios'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
    reduxFormSetIsSuccessToastOpenSite,
    reduxModalCalendarEmailInviteShowHideSite,
    reduxModalErrorEventHandlerSite,
} from 'data'

// services
import {
    axiosErrorHandlerSite,
    getApiUrlSiteV2,
    getAxiosHeadersSite,
} from 'services'

// main
export const CalendarEmailInviteModalSite: React.FC = () => {
    const dispatch = useDispatch()
    const reduxAuth = useSelector((state: defaultReduxState) => state.reduxAuth)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const [emailValue, setEmailValue] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const isOpen = reduxModalSite.calendarEmailInvite?.isOpen || false
    const eventId = reduxModalSite.calendarEmailInvite?.eventId

    function handleClose() {
        dispatch(reduxModalCalendarEmailInviteShowHideSite(false))
        setEmailValue('')
    }

    function handleSendEmailInvite() {
        try {
            if (!emailValue || !eventId) return

            setIsLoading(true)
            const getUrl = getApiUrlSiteV2('portfolio/site/form/event_notification/', reduxModalSite)
            axios({
                data: {
                    email: emailValue,
                    event_id: eventId,
                },
                headers: getAxiosHeadersSite(reduxAuth, reduxModalSite, dispatch),
                method: 'post',
                url: getUrl,
            })
                .then((response) => {
                    if (process.env.NODE_ENV === 'development') console.log(response)
                    handleClose()
                    dispatch(reduxFormSetIsSuccessToastOpenSite(true, 'Invitation envoyée avec succès !'))
                })
                .catch((error) => {
                    axiosErrorHandlerSite({
                        apiUrl: getUrl,
                        component: 'CalendarEmailInviteModalSite',
                        dispatch,
                        error,
                        reduxAuth,
                        reduxModalSite,
                        reference: 'handleSendEmailInvite',
                    })
                })
                .finally(() => {
                    setIsLoading(false)
                })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'CalendarEmailInviteModalSite',
                'handleSendEmailInvite',
            ))
            setIsLoading(false)
        }
    }

    return (
        <Dialog open={isOpen} onClose={handleClose}>
            <DialogTitle>Recevoir l'invitation par email</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Entrez votre adresse email pour recevoir l'invitation à cet événement directement dans votre calendrier.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="email"
                    label="Adresse Email"
                    type="email"
                    fullWidth
                    variant="standard"
                    value={emailValue}
                    onChange={(e) => setEmailValue(e.target.value)}
                    disabled={isLoading}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={isLoading}>Annuler</Button>
                <Button onClick={handleSendEmailInvite} disabled={isLoading || !emailValue}>
                    {isLoading ? 'Envoi...' : 'Valider'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
